export const GET_ACTIVE_ALARMS = 'GET_ACTIVE_ALARMS';
export const GET_ACTIVE_ALARMS_FAIL = 'GET_ACTIVE_ALARMS_FAIL';
export const GET_ACTIVE_ALARMS_SUCCESS = 'GET_ACTIVE_ALARMS_SUCCESS';

export const GET_ACTIVE_ALARMS_CRITICAL = 'GET_ACTIVE_ALARMS_CRITICAL';
export const GET_ACTIVE_ALARMS_CRITICAL_FAIL = 'GET_ACTIVE_ALARMS_CRITICAL_FAIL';
export const GET_ACTIVE_ALARMS_CRITICAL_SUCCESS = 'GET_ACTIVE_ALARMS_CRITICAL_SUCCESS';

export const GET_ACTIVE_ALARMS_MAJOR = 'GET_ACTIVE_ALARMS_MAJOR';
export const GET_ACTIVE_ALARMS_MAJOR_FAIL = 'GET_ACTIVE_ALARMS_MAJOR_FAIL';
export const GET_ACTIVE_ALARMS_MAJOR_SUCCESS = 'GET_ACTIVE_ALARMS_MAJOR_SUCCESS';

export const GET_ACTIVE_ALARMS_MINOR = 'GET_ACTIVE_ALARMS_MINOR';
export const GET_ACTIVE_ALARMS_MINOR_FAIL = 'GET_ACTIVE_ALARMS_MINOR_FAIL';
export const GET_ACTIVE_ALARMS_MINOR_SUCCESS = 'GET_ACTIVE_ALARMS_MINOR_SUCCESS';


// constants for acknowledge active alarm

export const ACK_ACTIVE_ALARM = 'ACK_ACTIVE_ALARM';
export const ACK_ACTIVE_ALARM_FAIL = 'ACK_ACTIVE_ALARM_FAIL';
export const ACK_ACTIVE_ALARM_SUCCESS = 'ACK_ACTIVE_ALARM_SUCCESS';
export const ACK_SUCCESS_MSG = 'ALARM_ACKNOWLEDGED_SUCCESSFULLY';
export const RESET_ACK_STATE = 'RESET_ACK_STATE';

//

export const GET_ADMIN_ACCOUNT_DETAILS = 'GET_ADMIN_ACCOUNT_DETAILS';
export const GET_ADMIN_ACCOUNT_DETAILS_FAIL = 'GET_ADMIN_ACCOUNT_DETAILS_FAIL';
export const GET_ADMIN_ACCOUNT_DETAILS_SUCCESS = 'GET_ADMIN_ACCOUNT_DETAILS_SUCCESS';

//
export const EMAIL_RECEPIENT_REQUEST_EDIT = 'EMAIL_RECEPIENT_REQUEST_EDIT';
export const EMAIL_RECEPIENT_RESPONSE_EDIT_SUCCESS = 'EMAIL_RECEPIENT_RESPONSE_EDIT_SUCCESS';
export const EMAIL_RECEPIENT_RESPONSE_EDIT_FAIL = 'EMAIL_RECEPIENT_RESPONSE_EDIT_FAIL';

//
export const ALARMS_COUNT_REQUEST_GET = 'ALARMS_COUNT_REQUEST_GET';
export const ALARMS_COUNT_RESPONSE_GET_FAIL = 'ALARMS_COUNT_RESPONSE_GET_FAIL';
export const ALARMS_COUNT_RESPONSE_GET_SUCCESS = 'ALARMS_COUNT_RESPONSE_GET_SUCCESS';

export const ALARMS_NOTIFICATION_DISABLE_REQUEST_UPDATE = 'ALARMS_NOTIFICATION_DISABLE_REQUEST_UPDATE';
export const ALARMS_NOTIFICATION_DISABLE_REQUEST_SUCCESS = 'ALARMS_NOTIFICATION_DISABLE_REQUEST_SUCCESS';
export const ALARMS_NOTIFICATION_DISABLE_REQUEST_FAIL = 'ALARMS_NOTIFICATION_DISABLE_REQUEST_FAIL';



